// Einstellungen aus dem Menü (Fabi, Phase Kern, 17.10.2026 nachts): bleiben im Browser, wie der Spielstand.
// Erste Fassung, Runde 5: Lautstärke für Gesamt, Musik und Geräusche (Hinweis des Sound-Leads).

export type Settings = {
  /** Tempo, mit dem jeder Kampf startet: 0,5×, 1×, 2× oder 4× */
  speed: number;
  /** T35: Fenster entfalten sich (erst die Überschrift, dann der Text, dann die Möglichkeiten) */
  unfold: boolean;
  /** Lautstärke 0 bis 1: alles, Musik, Geräusche (Teppiche, Streugeräusche, Kampf, Bedienung) */
  master: number;
  music: number;
  sounds: number;
  /** K46 Übungsufer (Vorschlag): Das Spiel hält von selbst an, wenn ein Kniff bereit wird oder ein großer Angriff kommt */
  autoPause: boolean;
};

const KEY = 'fff.settings.v1';
const DEFAULTS: Settings = { speed: 1, unfold: true, master: 0.8, music: 0.7, sounds: 0.8, autoPause: true };

let current: Settings = (() => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...(JSON.parse(raw) as Partial<Settings>) } : { ...DEFAULTS };
  } catch {
    return { ...DEFAULTS };
  }
})();

export const settings = (): Settings => current;

export function setSetting<K extends keyof Settings>(key: K, value: Settings[K]): void {
  current = { ...current, [key]: value };
  try {
    localStorage.setItem(KEY, JSON.stringify(current));
  } catch {
    // ohne Speicher gilt die Wahl bis zum Neuladen
  }
}
